// extracted by mini-css-extract-plugin
module.exports = {"menu-col":"admin_menu-col__1-7Hd","main-col":"admin_main-col__1dNHt"};